import { useEffect, useState } from 'react';
import { format } from 'date-fns';

import Humanograma from 'components/Humanograma';
import { UserAvatar } from 'components/user-avatar';
import { dimensaoByBehavior } from 'components/rebrand/mappings';
import { useAuth } from 'context/AuthContext';
import { getRewardFeed } from 'services/dashboard.service';
import { convertEmojis } from 'utils/helpers';

const PAGE_SIZE = 20;

interface Props {
  filter?: any;
}

export default function RecognitionFeed(_props: Props) {
  const { user, currentCycle } = useAuth();
  const [list, setList] = useState<any[]>([]);
  const [loadingList, setLoadingList] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    async function loadData() {
      if (!page) setLoadingList(true);
      const rangeItem = page ? page * 5 : 0;

      if (page) setLoad(true);

      const data = await getRewardFeed(currentCycle?.date_start, currentCycle?.date_finish, rangeItem, PAGE_SIZE);
      setList(prev => (page ? [...prev, ...data.result] : data.result));
      setTotalPage(data.range.pages);
      setLoadingList(false);
      setLoad(false);
    }

    if (!!user && !!currentCycle) {
      loadData();
    }
  }, [currentCycle, user, page]);

  if (loadingList) {
    return (
      <div className="rb-feed-grid">
        <div className="rb-skeleton" style={{ height: 150 }} />
        <div className="rb-skeleton" style={{ height: 150 }} />
      </div>
    );
  }

  if (!list?.length) {
    return <div className="rb-empty">Nenhum reconhecimento neste ciclo até o momento.</div>;
  }

  return (
    <>
      <div className="rb-feed-grid">
        {list.map((item: any) => {
          const dimensao = dimensaoByBehavior(item.behavior);
          return (
            <article key={item.action_id || item.time} className="rb-feedcard rb-rise" style={{ ['--acc' as any]: dimensao.color }}>
              <div className="rb-feedcard__head">
                <div className="rb-feedcard__avatar">
                  <UserAvatar data={{ ...item.target_avatar, ariaHidden: true }} responsive={true} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Humanograma
                    data={{
                      nome: item.target_name,
                      funcao: item.target_funcao,
                      diretoria: item.target_desc_unidade,
                      _id: item.target,
                    }}
                  >
                    <div className="rb-feedcard__title">
                      <strong>{item.target_nome_guerra || item.target_name?.split(' ')[0]}</strong> foi reconhecido
                    </div>
                  </Humanograma>
                  {!!(item.target_desc_unidade || item.target_funcao) && (
                    <div className="rb-feedcard__unit">{item.target_desc_unidade || item.target_funcao}</div>
                  )}
                </div>
                <span className="rb-feedcard__date">{format(new Date(item.time), 'dd MMM yyyy | HH:mm')}</span>
              </div>

              <div className="rb-feedcard__tags">
                <span className="rb-dimchip" style={{ color: dimensao.color, boxShadow: `inset 0 0 0 1.5px ${dimensao.color}` }}>
                  <span className="rb-dimchip__dot" style={{ background: dimensao.color }} />
                  {dimensao.label}
                </span>
              </div>

              {!!item.message && (
                <>
                  <div className="rb-feedcard__label">Reconhecimento:</div>
                  <div className="rb-feedcard__message" dangerouslySetInnerHTML={{ __html: convertEmojis(item.message) }} />
                </>
              )}
            </article>
          );
        })}
      </div>

      {page + 1 < totalPage && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
          <button type="button" className="rb-btn-primary" disabled={load} onClick={() => setPage(page + 1)}>
            {load ? 'Carregando...' : 'Carregar mais'}
          </button>
        </div>
      )}
    </>
  );
}
